import { MaintenanceWindowsAppView } from '../view/MaintenanceWindowsAppView';
import { templateMaintenanceWindowsApp } from '../view/template';
import { BaseWebComponentController, WebComponentEvent } from '../../../framework/BaseWebComponentController';
import { MaintenanceWindowsAppWebComponent } from '..';
import { MaintenanceWindowsAppWebComponentSchema } from '../types';
import { MaintenanceWindowsEvents } from '../../maintenanceWindowGrid/types';
import { MaintenanceWindowTypes } from '../../../types/common/maintenanceWindowTypes';
import { translateFn } from '../../../utils/translator.helper';

export class MaintenanceWindowsAppController extends BaseWebComponentController {
  public component: MaintenanceWindowsAppWebComponent;
  public view: MaintenanceWindowsAppView;
  public viewConstructor: typeof MaintenanceWindowsAppView;

  constructor(component: MaintenanceWindowsAppWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: MaintenanceWindowsAppView,
      viewTemplate: templateMaintenanceWindowsApp,
    });
  }

  computeEventListeners() {
    return [
      {
        element: this.view.dom.$maintenanceWindowsGrid,
        event: MaintenanceWindowsEvents.ADD_MAINTENANCE_WINDOW,
        callback: this.addMaintenanceWindow,
      },
      {
        element: this.view.dom.$maintenanceWindowsGrid,
        event: MaintenanceWindowsEvents.RELOAD_GRID,
        callback: this.triggerGridReload,
      },
      {
        element: this.view.dom.$maintenanceWindowForm,
        event: MaintenanceWindowsEvents.RELOAD_GRID,
        callback: this.triggerGridReload,
      },
      {
        element: this.view.dom.$maintenanceWindowSideNav,
        event: MaintenanceWindowsEvents.SHOW_ALL_PATCHES,
        callback: this.showAllPatches,
      },
      {
        element: this.view.dom.$maintenanceWindowSideNav,
        event: MaintenanceWindowsEvents.SHOW_SECURITY_PATCHES,
        callback: this.showSecurityPatches,
      },
      {
        element: this.view.dom.$maintenanceWindowSideNav,
        event: MaintenanceWindowsEvents.SHOW_NON_SECURITY_PATCHES,
        callback: this.showNonSecurityPatches,
      },
      {
        element: this.view.dom.$maintenanceWindowSideNav,
        event: MaintenanceWindowsEvents.SHOW_MANUALLY_APPROVED_PATCHES,
        callback: this.showManuallyApprovedPatches,
      },
    ];
  }

  public triggerGridReload() {
    const maintenanceWindowGrid = this.view.dom.$maintenanceWindowsGrid;
    const maintenanceWindowGridView = maintenanceWindowGrid.controller.view.dom.$gridView;

    maintenanceWindowGridView.propertiesSet = true;
  }

  public addMaintenanceWindow(ev: WebComponentEvent) {
    this.view.dom.$maintenanceWindowForm.maintenanceWindowType = MaintenanceWindowTypes.PATCH_MANAGEMENT.toString();

    this.view.dom.$maintenanceWindowForm.maintenanceWindowId = ev.detail._id;

    if (this.view.dom.$maintenanceWindowForm.injectDependencies) {
      this.view.dom.$maintenanceWindowForm.injectDependencies(this.dependencies);
      this.view.dom.$maintenanceWindowForm.start().catch(console.error);
    }

    this.view.showMaintenanceWindowForm();
  }

  async getDataForView(): Promise<MaintenanceWindowsAppWebComponentSchema> {
    return {};
  }

  showAllPatches(ev: WebComponentEvent) {
    this.view.dom.$maintenanceWindowsGrid.sideNavFilters = {};
    this.view.dom.$maintenanceWindowsGrid.gridTitle = translateFn('All maintenance windows');
  }
  showSecurityPatches(ev: WebComponentEvent) {
    this.view.dom.$maintenanceWindowsGrid.sideNavFilters = {
      'specifics.installPatchesSettings.updateType.securityPatchesSettings.enabled': true,
    };
    this.view.dom.$maintenanceWindowsGrid.gridTitle = translateFn(
      'All maintenance windows that install security patches'
    );
  }
  showNonSecurityPatches(ev: WebComponentEvent) {
    this.view.dom.$maintenanceWindowsGrid.sideNavFilters = {
      'specifics.installPatchesSettings.updateType.nonSecurityPatchesSettings.enabled': true,
    };
    this.view.dom.$maintenanceWindowsGrid.gridTitle = translateFn(
      'All maintenance windows that install non-security patches'
    );
  }
  showManuallyApprovedPatches(ev: WebComponentEvent) {
    this.view.dom.$maintenanceWindowsGrid.sideNavFilters = {
      'specifics.installPatchesSettings.updateType.manuallyApprovedPatchesSettings.enabled': true,
    };
    this.view.dom.$maintenanceWindowsGrid.gridTitle = translateFn(
      'All maintenance windows that install manually approved patches'
    );
  }
}
